const Actions = Object.freeze({
  INDEX: Symbol('index'),
  SHOW: Symbol('show'),
  CREATE: Symbol('create'),
  UPDATE: Symbol('update'),
  DESTROY: Symbol('destroy'),
})

export default Actions
